import React, { useState, useEffect } from 'react';
import {
  Typography, TextField, Button,
  Alert, Paper, Container, Box, Slide
} from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/Register.css';
import '../css/FormLayout.css';
import API_BASE_URL from '../api';

const Register = () => {
  const [formData, setFormData] = useState({
    lastName: '',
    firstName: '',
    emailAddress: '',
    password: '',
    arrive: 'ESN',
    address: '',
    societe: 'Entreprise',
    siret: '11111111111111',
    userType: 'user',
  });

  const [verificationCode, setVerificationCode] = useState('');
  const [showVerificationForm, setShowVerificationForm] = useState(false);
  const [isVerificationDisabled, setIsVerificationDisabled] = useState(false);
  const [showConnectMessage, setShowConnectMessage] = useState(false);
  const [messages, setMessages] = useState({ success: '', error: '' });

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) navigate('/dashboard');
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSuccess = (msg) => setMessages({ success: msg, error: '' });
  const handleError = (msg) => setMessages({ success: '', error: msg });

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    if (!formData.emailAddress.endsWith('@consult-it.com')) {
      return handleError("Seules les adresses @consult-it.com sont autorisées.");
    }

    try {
      const userResponse = await axios({
        method: 'post',
        url: `${API_BASE_URL}/api/users/register`,
        headers: { 'Content-Type': 'application/json' },
        data: formData
      });

      const user = userResponse.data.user;

      {/*if (user && formData.siret) {
        await axios.post(`${API_BASE_URL}/api/societes`, {
          siret: formData.siret,
          nom: formData.societe,
          userId: user._id
        });
      }*/}

      localStorage.setItem('arrive', user.arrive);
      localStorage.setItem('userType', user.userType);
      handleSuccess("Inscription complétée. Vérifiez votre email.");
      setShowVerificationForm(true);
    } catch (error) {
      if (error.response?.data?.message === 'User already exists') {
        handleError("Adresse mail existe déjà. Cliquez ici pour vous connecter.");
      } else {
        handleError("Erreur lors de l'inscription.");
      }
    }
  };

  const handleVerificationSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/users/verify`, {
        emailAddress: formData.emailAddress,
        verificationCode,
      });
      handleSuccess('Compte vérifié avec succès.');
      setShowConnectMessage(true);
      setIsVerificationDisabled(true);
      setTimeout(() => navigate('/login'), 5000);
    } catch {
      handleError('Erreur lors de la vérification.');
    }
  };

  return (
    <Box className="layout-wrapper">
      <Box className="info-section-layout">
        <Box className="info-content">
          <Typography variant="h5" className="info-title">
            Créer votre compte interne
          </Typography>
          <Typography variant="body1" className="info-subtitle">
            Réservé à l’équipe Consult IT 
          </Typography>
          <ul className="info-points">
            <li>✓ Compte validé par code de vérification</li>
            <li>✓ Réservé à l'équipe interne uniquement</li>
            <li>✓ Connexion sécurisée à votre espace</li>
          </ul>
        </Box>
      </Box>

      <Box className="form-section">
        <Container maxWidth="sm">
          <Slide in direction="up" timeout={500}>
            <Paper className="form-paper" elevation={6}>
              {messages.error && <Alert severity="error" sx={{ mb: 2 }}>{messages.error}</Alert>}
              {messages.success && <Alert severity="success" sx={{ mb: 2 }}>{messages.success}</Alert>}

              {!showVerificationForm && (
                <form onSubmit={handleRegisterSubmit}>
                  <Typography variant="h5" align="center" gutterBottom>
                    Créer votre compte
                  </Typography>
                  <TextField
                    label="Nom *"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                  />
                  <TextField
                    label="Prénom *"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                  />
                  <TextField
                    label="Email professionnel *"
                    name="emailAddress"
                    type="email"
                    value={formData.emailAddress}
                    onChange={handleChange}
                    helperText="Seules les adresses @consult-it.com sont autorisées"
                    fullWidth
                    margin="normal"
                  />
                  <TextField
                    label="Mot de passe *"
                    name="password"
                    type="password"
                    value={formData.password}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                  />
                  <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
                    Créer
                  </Button>
                </form>
              )}

              {showVerificationForm && (
                <form onSubmit={handleVerificationSubmit}>
                  <Typography variant="h6" gutterBottom>
                    Vérification de l'email
                  </Typography>
                  <TextField
                    label="Code de vérification"
                    name="verificationCode"
                    value={verificationCode}
                    onChange={(e) => setVerificationCode(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                  <Button
                    type="submit"
                    variant="outlined"
                    fullWidth
                    disabled={isVerificationDisabled}
                  >
                    Vérifier mon compte
                  </Button>
                </form>
              )}

              {showConnectMessage && (
                <Typography align="center" sx={{ mt: 2 }}>
                  Compte vérifié. <a href="/login">Connectez-vous maintenant</a>.
                </Typography>
              )}
            </Paper>
          </Slide>
        </Container>
      </Box>
    </Box>
  );
};

export default Register;
